export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  tags: string[];
  updatedAt: string;
  status: '连载中' | '已完结';
  chapters: number;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '热血', icon: 'ri-fire-line', count: 87 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 74 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 63 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 55 },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line', count: 92 },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-sun-line', count: 48 },
];

export const hotComics: Comic[] = [
  {
    id: 'comic-001',
    title: '霸道总裁的契约新娘',
    author: '金智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20featuring%20an%20elegant%20woman%20in%20a%20wedding%20dress%20with%20a%20handsome%20man%20in%20a%20suit%2C%20soft%20pink%20and%20gold%20tones%2C%20dreamy%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20white%20background%20with%20subtle%20rose%20petals&width=600&height=800&seq=hot-comic-01&orientation=portrait',
    category: '恋爱',
    description: '为了拯救家族企业，她被迫与冷酷无情的总裁签订契约婚姻。原以为只是一场交易，却在朝夕相处中渐渐沦陷……',
    rating: 9.5,
    views: 3280000,
    tags: ['恋爱', '契约婚姻', '霸道总裁', '都市'],
    updatedAt: '2026-08-03',
    status: '连载中',
    chapters: 86,
  },
  {
    id: 'comic-002',
    title: '重生之异世界王者',
    author: '朴志勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20fantasy%20webtoon%20cover%20with%20a%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20world%2C%20dramatic%20lighting%2C%20epic%20fantasy%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20background%20with%20light%20particles&width=600&height=800&seq=hot-comic-02&orientation=portrait',
    category: '奇幻',
    description: '普通上班族意外穿越到剑与魔法的世界，凭借前世记忆成为最强王者。冒险与战斗的史诗篇章就此展开！',
    rating: 9.7,
    views: 5120000,
    tags: ['奇幻', '异世界', '重生', '战斗'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 142,
  },
  {
    id: 'comic-003',
    title: '我的青梅竹马不可能这么可爱',
    author: '李美英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20school%20romance%20webtoon%20cover%20with%20a%20cute%20high%20school%20girl%20and%20boy%20sharing%20earphones%20under%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20youthful%20and%20fresh%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20white%20background&width=600&height=800&seq=hot-comic-03&orientation=portrait',
    category: '恋爱',
    description: '从小学到高中一直在一起的青梅竹马。当她突然变得异常可爱时，少年的心跳再也无法平静……',
    rating: 9.3,
    views: 2890000,
    tags: ['恋爱', '校园', '青梅竹马', '日常'],
    updatedAt: '2026-08-02',
    status: '连载中',
    chapters: 64,
  },
  {
    id: 'comic-004',
    title: '暗黑之城',
    author: '赵民基',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20mysterious%20Korean%20thriller%20webtoon%20cover%20with%20a%20detective%20in%20a%20rainy%20city%20alley%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20manhwa%20art%20style%2C%20clean%20dark%20gray%20background&width=600&height=800&seq=hot-comic-04&orientation=portrait',
    category: '悬疑',
    description: '连环杀人案笼罩暗黑之城。天才刑警与犯罪心理学家联手，揭开这座城市最深的秘密。每一步都在深渊边缘！',
    rating: 9.6,
    views: 4010000,
    tags: ['悬疑', '犯罪', '推理', '都市'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 98,
  },
  {
    id: 'comic-005',
    title: '星光璀璨的夜晚',
    author: '崔秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20BL%20webtoon%20cover%20with%20two%20handsome%20young%20men%20gazing%20at%20stars%20together%20on%20a%20rooftop%2C%20warm%20night%20atmosphere%2C%20soft%20lighting%2C%20manhwa%20art%20style%2C%20clean%20background%20with%20starry%20sky&width=600&height=800&seq=hot-comic-05&orientation=portrait',
    category: '耽美',
    description: '音乐天才与普通大学生的命运邂逅。在星光璀璨的夜晚，两颗孤独的心慢慢靠近，谱写出一段动人的旋律。',
    rating: 9.4,
    views: 3560000,
    tags: ['耽美', '音乐', '治愈', '都市'],
    updatedAt: '2026-08-03',
    status: '连载中',
    chapters: 72,
  },
  {
    id: 'comic-006',
    title: '最强赘婿',
    author: '金武成',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20webtoon%20cover%20with%20a%20powerful%20martial%20artist%20in%20modern%20clothing%20surrounded%20by%20energy%2C%20intense%20action%20pose%2C%20manhwa%20art%20style%2C%20clean%20background%20with%20speed%20lines&width=600&height=800&seq=hot-comic-06&orientation=portrait',
    category: '热血',
    description: '隐世高手入赘豪门，众人嘲笑他是吃软饭的废物。当危机降临，他用铁拳让所有人闭嘴！',
    rating: 9.2,
    views: 4670000,
    tags: ['热血', '战斗', '逆袭', '都市'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 115,
  },
];

export const latestComics: Comic[] = [
  {
    id: 'comic-007',
    title: '美食的诱惑：异世界食堂',
    author: '金善雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20delicious%20Korean%20food-themed%20webtoon%20cover%20with%20a%20cheerful%20chef%20presenting%20colorful%20dishes%20in%20a%20magical%20restaurant%2C%20warm%20and%20inviting%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20beige%20background&width=600&height=800&seq=latest-comic-01&orientation=portrait',
    category: '奇幻',
    description: '在异世界开设一家温暖的小食堂，用美食治愈每一个疲惫的灵魂。每一道菜背后，都藏着一个动人的故事。',
    rating: 9.1,
    views: 1560000,
    tags: ['奇幻', '美食', '治愈', '日常'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 48,
  },
  {
    id: 'comic-008',
    title: '校园风云录',
    author: '刘志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20school%20comedy%20webtoon%20cover%20with%20a%20group%20of%20high%20school%20students%20laughing%20together%2C%20bright%20and%20colorful%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20white%20background&width=600&height=800&seq=latest-comic-02&orientation=portrait',
    category: '搞笑',
    description: '四个性格迥异的高中生组成了校园最奇葩的社团。每天都是笑料百出、鸡飞狗跳的爆笑日常！',
    rating: 8.9,
    views: 2340000,
    tags: ['搞笑', '校园', '日常', '青春'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 55,
  },
  {
    id: 'comic-009',
    title: '女王之路',
    author: '郑慧珍',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20elegant%20Korean%20historical%20drama%20webtoon%20cover%20with%20a%20noble%20woman%20in%20traditional%20hanbok%20standing%20in%20a%20palace%2C%20regal%20and%20dignified%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20cream%20background&width=600&height=800&seq=latest-comic-03&orientation=portrait',
    category: '剧情',
    description: '从卑微宫女到一代女王，她用智慧与勇气在尔虞我诈的宫廷中杀出一条血路。女性力量史诗巨作！',
    rating: 9.8,
    views: 3890000,
    tags: ['剧情', '历史', '女性', '宫廷'],
    updatedAt: '2026-08-04',
    status: '已完结',
    chapters: 120,
  },
  {
    id: 'comic-010',
    title: '野兽都巿',
    author: '高东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gritty%20Korean%20action%20noir%20webtoon%20cover%20with%20a%20tough%20man%20in%20a%20leather%20jacket%20in%20a%20dark%20alley%2C%20gritty%20urban%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20dark%20background&width=600&height=800&seq=latest-comic-04&orientation=portrait',
    category: '热血',
    description: '地下世界的王者归来，野兽般的本能在这座钢铁丛林中苏醒。金钱、权力、复仇，一切尽在拳下！',
    rating: 9.0,
    views: 1980000,
    tags: ['热血', '战斗', '黑道', '都市'],
    updatedAt: '2026-08-03',
    status: '连载中',
    chapters: 78,
  },
  {
    id: 'comic-011',
    title: '纯情房东俏房客',
    author: '林秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20romantic%20comedy%20webtoon%20cover%20with%20a%20shy%20man%20surrounded%20by%20beautiful%20women%20in%20a%20shared%20house%2C%20playful%20and%20lighthearted%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20pastel%20background&width=600&height=800&seq=latest-comic-05&orientation=portrait',
    category: '搞笑',
    description: '大学生租了一间便宜的房子，没想到里面住着五个性格各异的美女。每天都是甜蜜又混乱的生活！',
    rating: 8.8,
    views: 3120000,
    tags: ['搞笑', '恋爱', '日常', '合租'],
    updatedAt: '2026-08-03',
    status: '连载中',
    chapters: 92,
  },
  {
    id: 'comic-012',
    title: '无限之塔',
    author: '朴龙河',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20fantasy%20webtoon%20cover%20with%20a%20towering%20mystical%20tower%20reaching%20into%20the%20clouds%2C%20adventurers%20at%20the%20base%2C%20epic%20and%20awe-inspiring%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20gradient%20background&width=600&height=800&seq=latest-comic-06&orientation=portrait',
    category: '奇幻',
    description: '一座无限延伸的神秘之塔突然出现在世界中心。登塔者可以获得任何愿望，但每一层都是生死考验！',
    rating: 9.5,
    views: 5430000,
    tags: ['奇幻', '冒险', '战斗', '生存'],
    updatedAt: '2026-08-04',
    status: '连载中',
    chapters: 168,
  },
];

export const allComics: Comic[] = [...hotComics, ...latestComics];

export const siteInfo = {
  name: '韩漫网',
  slogan: '好看的韩国漫画在线免费阅读',
  description: '韩漫网汇聚众多好看韩国漫画，支持韩漫在线免费阅读，大全内容包含各种热门精选，满足您的不同阅读口味。',
  email: 'contact@hanmanwang.com',
  year: 2026,
};